<template>
  <div class="filters mb-4">
    <v-row class="mb-4" dense>
      <v-col cols="12" sm="6" md="12">
        <v-autocomplete
          v-model="filters.supplier_id"
          :items="suppliers"
          item-text="name"
          item-value="id"
          label="Buscar proveedor"
          clearable
          outlined
          dense
          hide-details
          white
        />
      </v-col>

      <v-col cols="6" sm="6" md="6">
        <v-menu
          v-model="menu.from"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="filters.date_from"
              label="Desde"
              prepend-icon="mdi-calendar"
              readonly
              outlined
              dense
              hide-details
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="filters.date_from"
            @input="menu.from = false"
            no-title
            locale="es"
          />
        </v-menu>
      </v-col>

      <v-col cols="6" sm="6" md="6">
        <v-menu
          v-model="menu.to"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="filters.date_to"
              label="Hasta"
              prepend-icon="mdi-calendar"
              readonly
              outlined
              dense
              hide-details
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="filters.date_to"
            @input="menu.to = false"
            no-title
            locale="es"
          />
        </v-menu>
      </v-col>

      <v-col cols="12" sm="12" class="">
        <v-btn
          small
          color="black"
          class="text-white mt-4"
          @click="emitFilters"
          block
          elevation="0"
          style="border-radius: 16px"
        >
          Aplicar filtros
        </v-btn>
        <v-btn
          small
          color="black"
          class="text-white mt-4"
          @click="close"
          block
          outlined
          elevation="0"
          style="border-radius: 16px"
        >
          Cerar
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
    suppliers: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      menu: {
        from: false,
        to: false,
      },
    };
  },

  mounted() {
    console.log(this.suppliers);
  },

  methods: {
    emitFilters() {
      this.$emit("change", { ...this.filters });
    },

    close() {
      this.$emit("close");
    },
  },

  computed: {
    filters: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>

<style>
.filters {
  padding: 10px 16px;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
</style>
